import React from 'react';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full bg-gradient-to-b from-lavender-light to-cream pt-12 pb-20 px-6 md:px-8 lg:px-12 overflow-hidden" style={{
    paddingTop: '20px',
    paddingBottom: '20px',
    paddingLeft: '20px',
    paddingRight: '20px'
  }} data-id="element-121">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-122">
        {/* Headline Group */}
        <div className="mb-8 space-y-4" data-id="element-123">
          <span className="inline-block px-4 py-1.5 rounded-full bg-white/60 text-text-light text-sm font-medium tracking-wide border border-lavender/30" data-id="element-124">
            Plan de Supervivencia Postparto (0–30 días)
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-text" data-id="element-125">
            El posparto no se 'supera'. <br className="hidden md:block" data-id="element-126" />
            <span className="italic text-lavender-dark" data-id="element-127">
              Se sobrevive con un guión.
            </span>
          </h1>
        </div>

        {/* Opening Lead */}
        <div className="max-w-2xl mx-auto mb-12 text-lg md:text-xl leading-relaxed text-text/90 space-y-6 text-left md:text-center bg-white/40 p-6 md:p-8 rounded-2xl backdrop-blur-sm border border-white/50 shadow-sm" data-id="element-128">
          <p data-id="element-129">A nadie le gusta decirlo en voz alta, pero aquí va:</p>
          <p className="font-medium text-text" data-id="element-130">
            El posparto no solo cansa. Te desordena por dentro.
          </p>

          <div className="pl-4 border-l-4 border-lavender italic text-text-light space-y-2 my-6" data-id="element-131">
            <p data-id="element-132">"¿Comí algo hoy?"</p>
            <p data-id="element-133">"¿Me bañé?"</p>
            <p data-id="element-134">"¿Por qué estoy llorando?"</p>
            <p data-id="element-135">"¿Qué se supone que haga ahora?"</p>
          </div>

          <p data-id="element-136">
            Y lo peor es que, desde fuera, todos creen que "estás bien". Porque
            el bebé está bien. Entonces tú… desapareces.
          </p>

          <p className="font-semibold text-text text-xl pt-2" data-id="element-137">
            Este PDF existe para una cosa: que no tengas que pensar cuando no
            puedes pensar.
          </p>
        </div>

        {/* Mockup Image */}
        <div className="relative w-full max-w-2xl mb-12 shadow-2xl rounded-2xl overflow-hidden transform hover:scale-[1.01] transition-transform duration-500" data-id="element-138">
          <img src="https://cdn.magicpatterns.com/uploads/6U8PtuKcfmMad5JTsgkXLf/Mockup_mama_con_ipad_y_cel.png" alt="Mockup del Plan de Supervivencia Postparto en iPad y celular" className="w-full h-auto object-cover" data-id="element-139" />
        </div>

        {/* CTA */}
        <a href="#offer-price" className="group flex items-center gap-3 bg-lavender-dark hover:bg-text text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1" data-id="element-140">
          Descarga tu guión
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-141" />
        </a>
        <p className="mt-4 text-sm text-text-light" data-id="element-142">
          Descarga inmediata • Acceso de por vida
        </p>
      </div>
    </section>;
}